import { trackError } from './trackError';

export const trackHeadlessError = (
  error: unknown,
  errorInfo?: { componentStack?: string }
) => {
  const meta: Record<string, unknown> = {
    app: 'HEADLESS_CHECKOUT',
    url: typeof window !== 'undefined' ? window.location.href : 'unknown',
  };

  if (errorInfo?.componentStack) {
    meta['componentStack'] = errorInfo.componentStack;
  }

  if (error instanceof Error) {
    const prefixedError = new Error(`[HEADLESS] ${error.message}`);
    prefixedError.stack = error.stack;
    prefixedError.name = error.name;
    trackError(prefixedError, meta);
  } else {
    trackError(new Error(`[HEADLESS] ${String(error)}`), meta);
  }
};
